module.exports = __webpack_public_path__ + "img/what_is_a_profile.f3235947.png";